module.exports = __webpack_public_path__ + "static/img/Chris-Goulding.c865a89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Chris-Goulding.jpg
// module id = WCVc
// module chunks = 1